import type { AssetType } from '@/lib/types/property';

export const ASSET_TYPE_LABELS: Record<AssetType, string> = {
  industrial: 'Industrial',
  flex: 'Flex',
  retail: 'Retail',
  office: 'Office',
};

export const ASSET_TYPE_OPTIONS = Object.keys(ASSET_TYPE_LABELS) as AssetType[];

export const SUBMARKET_OPTIONS = [
  'Downtown West',
  'King West',
  'Stockyards',
  'North York',
  'Downsview',
  'Victoria Park & St Clair',
] as const;

export type SubmarketOption = (typeof SUBMARKET_OPTIONS)[number];

export function formatAssetTypeLabel(value: AssetType): string {
  return ASSET_TYPE_LABELS[value];
}
